import Venues from './Venues';

const CourseDates = props => {
  if (props.dates.length > 0) {
    let datesElements = props.dates.map((date, index) => {
      let startDate = date.startDate && new Date(date.startDate.replace(/\s+/g, 'T') + 'Z');
      let endDate = date.endDate && new Date(date.endDate);
      let startMillisecondsIndex = date.startTimeString.lastIndexOf(':00');
      let endMillisecondsIndex = date.endTimeString.lastIndexOf(':00');

      let startTime = date.startTimeString.slice(0, startMillisecondsIndex) + date.startTimeString.slice(startMillisecondsIndex).replace(':00', '');
      let endTime = date.endTimeString.slice(0, endMillisecondsIndex) + date.endTimeString.slice(endMillisecondsIndex).replace(':00', '');
      return <tr key={date.courseDateId}>
        <td>
          {startDate && new Intl.DateTimeFormat("en-GB", {
            year: "2-digit",
            month: "short",
            day: "2-digit",
            weekday: 'short'
          }).format(startDate)}
        </td>
        <td>
          {endDate && new Intl.DateTimeFormat("en-GB", {
            year: "2-digit",
            month: "short",
            day: "2-digit",
            weekday: 'short'
          }).format(endDate)}
        </td>
        <td>
          {startTime} - {endTime}
        </td>
        <td>
          <Venues venues={props.venues} venueids={date.venueIds} />
        </td>
        <td>
          {date.cost > 0 ? <div>{date.currencySymbol}{date.cost}</div> : "Free"}
        </td>
        <td>
          {date.status === "Cancelled" ? <div className="alert alert-danger">Cancelled</div> : ""}
          {date.status === "FullyBooked" && date.bookNowURL !== "" ? <a href={date.bookNowURL} className="btn btn-info">Waiting list</a> : ""}
          {date.status === "Available" && date.bookNowURL !== "" ? <a href={date.bookNowURL} className="btn btn-info">Book</a> : ""}
        </td>
      </tr>
    });
    return (<div className="col-md-12">
      <h3>Availability</h3>
      <table className="table">
        <thead>
          <tr>
            <th>First session</th>
            <th>Last session</th>
            <th>Start/end time</th>
            <th>Location</th>
            <th>Cost</th>
            <th>Availability</th>
          </tr>
        </thead>
        <tbody>
          {datesElements}
        </tbody>
      </table>
    </div>);
  } else {
    return (<div className="col-md-12"><h3>Availability</h3><div className="nodates">No course dates available</div></div>);
  }
}

export default CourseDates;
